export class JobParam {

    JobName: string;
    paramName: string;
    ParamOrder: number;
    Id: number;

    constructor() { }
}